import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import UIText from "@streeteasy/design-system/deprecated/Text";

import { smallScreen } from "src/shared/constants/screenSizes";

import Avatar from "../Avatar";

export const ContactAvatar = styled(Avatar)`
  align-self: center;
`;

export const InfoWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const InfoContainer = styled.div`
  cursor: default;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  line-height: 18px;
  max-width: ${({ hidePhone }) =>
    hidePhone ? "inherit" : `calc(100% - ${90 + 25}px)`};
`;

export const DesktopOnly = styled.span`
  display: none;
  @media screen and (min-width: ${smallScreen}px) {
    display: inline;
  }
`;

export const InfoDealsButton = styled.button`
  background: none;
  border: none;
  color: ${colors.primary};
  font-family: "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  font-size: 14px;
  margin: 0;
  padding: 0;
  text-align: left;
`;

export const InfoButton = styled(InfoDealsButton)`
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  width: 100%;

  @media screen and (min-width: ${smallScreen}px) {
    margin-bottom: 8px;
  }

  ${({ type }) =>
    type === "span" &&
    `
        color: ${colors.whaleGrey};
      `}
`;

export const PhoneIcon = styled(FontAwesomeIcon).attrs({
  color: "primary",
  desktopPadding: "0",
  fontSize: "24px",
  iconClass: "phone"
})`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-width: 25px;
`;

export const PhoneLink = styled.a`
  text-decoration: none;
`;

export const Text = styled(UIText).attrs({
  type: "sm"
})`
  line-height: 22px;
`;

export const AdvertisementDisclosure = styled(UIText).attrs({
  type: "sm"
})`
  font-style: italic;
  line-height: 18px;
  color: ${colors.wolfGrey};
`;
